<script>
/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  defineComponent,
  ref,
  computed,
  reactive,
  watchEffect,
  watch,
  onMounted,
} from "@vue/composition-api";
import EditModal from "./components/EditModal.vue";
import {
  CheckProjectServiceProxy,
  CheckItemServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
import useTable from "@/hooks/useTable";
import useModal from "@/hooks/useModal";
import CodeModel from '@/components/CodeModel/index'
import {
  exportCheckProjectAndItem,
  exportCheckProjectTemplate,
  importProducts,
} from "@/api/api";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
const codersp = new CodeRuleServiceProxy();

const cpsp = new CheckProjectServiceProxy();
const cisp = new CheckItemServiceProxy();

function uniqPush(array, value) {
  if (!array.includes(value)) array.push(value);
}

export default defineComponent({
  components: {
    EditModal,
    CodeModel
  },
  setup(_, { root }) {
    onMounted(() => getCodeRules());

    const isUpdate = ref(false);
    const {
      tableAttrs: projectTableAttrs,
      currentRecord: currentProject,
      isUpdatable,
      isDeletable,
      isPrint,
      create: createCheckProject,
      read: readCheckProject,
      del: deleteCheckProject,
    } = useTable(
      {
        class: "mt-4",
        columns: [
          {
            key: "action",
            title: "操作",
            scopedSlots: { customRender: "action" },
            i18n: "actions",
          },
          {
            dataIndex: "code",
            title: "点检编码",
            i18n: "page_tpm_check_project_code",
          },
          {
            dataIndex: "name",
            title: "点检项目",
            i18n: "page_tpm_check_project_name",
          },
          {
            dataIndex: "remark",
            title: "备注",
            i18n: "page_tpm_check_project_remark",
          },
        ],
      },
      {
        create: cpsp.createCheckProject.bind(cpsp),
        update: cpsp.updateCheckProjectAndItems.bind(cpsp),
        read: cpsp.pageCheckProjects.bind(cpsp),
        delete: cpsp.deleteCheckProjectsByIds.bind(cpsp),
      },
      (record) =>
        readCheckItem(
          itemTableAttrs.pagination.current,
          record.id,
          itemTableAttrs.pagination.pageSize
        ),
      (page, pageSize) =>
        readCheckProject({
          keyWord: keyword.value,
          query: { current: page, size: pageSize },
        }),
      () => {
        if (itemTableAttrs) itemTableAttrs.dataSource = [];
      }
    );

    const { tableAttrs: itemTableAttrs, read: readCheckItem } = useTable(
      {
        columns: [
          {
            dataIndex: "name",
            title: "点检项",
            i18n: "page_tpm_check_item_name",
          },
          {
            dataIndex: "valueType",
            title: "数值类型",
            i18n: "page_tpm_check_item_type",
          },
          {
            dataIndex: "requirement",
            title: "点检要求",
            i18n: "page_tpm_check_item_require",
          },
          {
            dataIndex: "standardValue",
            title: "标准数值",
            i18n: "page_tpm_check_item_standard",
          },
        ],
        rowSelection: null,
      },
      { read: cisp.pageCheckItems.bind(cisp) },
      undefined,
      (current = 1, pageSize) =>
        readCheckItem(current, currentProject.value.id, pageSize)
    );

    const visible = reactive({
      editModal: false,
    });

    const keyword = ref("");
    const printVisible = ref(false)
    let checkList = ref([]);
    let dataList = ref([])
    const openEditModal = (bool = false) => {
      if (bool) isUpdate.value = true;
      visible.editModal = true;
    };
    const getCodeRules = async () => {
      const res = await codersp.list("CheckObject");
      checkList.value = res;
    };
    const printing = () => {
      const {dataSource,rowSelection:{selectedRowKeys}} = projectTableAttrs
      dataList.value = []
      selectedRowKeys.map(id =>{
        dataSource.map(item => {
          if(id === item.id) {
            dataList.value.push({
              code: item.code,
              name: item.name
            })
          }
        })
      })
      printVisible.value = true
    }

    const cancel =() => {
       readCheckProject({
        keyWord: keyword.value,
        query: {
          current: projectTableAttrs.pagination.current,
          size: projectTableAttrs.pagination.pageSize,
        },
      });
      printVisible.value = false
    }
    const handlerPrint = () => {
      readCheckProject({
        keyWord: keyword.value,
        query: {
          current: projectTableAttrs.pagination.current,
          size: projectTableAttrs.pagination.pageSize,
        },
      });
      printVisible.value = false
    }
    const closeEditModal = () => {
      if (isUpdate.value) isUpdate.value = false;
      visible.editModal = false;
      readCheckProject({
        keyWord: keyword.value,
        query: {
          current: projectTableAttrs.pagination.current,
          size: projectTableAttrs.pagination.pageSize,
        },
      });
    };

    const onSearch = (value) => {
      projectTableAttrs.pagination.current = 1;
      readCheckProject({
        keyWord: keyword.value,
        query: {
          current: projectTableAttrs.pagination.current,
          size: projectTableAttrs.pagination.pageSize,
        },
      });
    };

    const remove = async (ids) => {
      root.$confirm({
        title: root.$t("delete_tips"),
        okText: root.$t("yes"),
        okType: "danger",
        cancelText: root.$t("no"),
        async onOk() {
          await deleteCheckProject(
            Array.isArray(ids)
              ? ids
              : projectTableAttrs.rowSelection.selectedRowKeys
          );
          readCheckProject({
            keyWord: keyword.value,
            query: {
              current: projectTableAttrs.pagination.current,
              size: projectTableAttrs.pagination.pageSize,
            },
          });
        },
      });
    };

    watch(
      () => itemTableAttrs.dataSource,
      (val) => {
        currentProject.value.list = val;
      }
    );

    const exportButtonAttrs = reactive({
      class: "ml-2",
      exportFn: computed(() =>
        exportCheckProjectAndItem.bind(cpsp, currentProject.value.id)
      ),
      filename: "点检项目.xlsx",
      disabled: computed(() => !isUpdatable.value),
      simple: true,
    });
    const importButtonAttrs = reactive({
      class: "ml-2",
      importFn: importProducts.bind(cpsp),
      downloadFn: exportCheckProjectTemplate.bind(cpsp),
      filename: "点检项目模板.xlsx",
      newResFlag: true,
      refresh: () =>
        readCheckProject({
          keyWord: keyword.value,
          query: {
            current: projectTableAttrs.pagination.current,
            size: projectTableAttrs.pagination.pageSize,
          },
        }),
    });
    readCheckProject({
      keyWord: keyword.value,
      query: {
        current: projectTableAttrs.pagination.current,
        size: projectTableAttrs.pagination.pageSize,
      },
    });

    return {
      projectTableAttrs,
      currentProject,
      isUpdatable,
      isDeletable,
      isPrint,

      itemTableAttrs,

      onSearch,

      visible,
      openEditModal,
      closeEditModal,

      isUpdate,

      remove,
      keyword,

      exportButtonAttrs,
      importButtonAttrs,

      checkList,
      dataList,
      getCodeRules,
      printVisible,
      printing,
      cancel,
      handlerPrint
    };
  },
});
</script>

<template>
  <div style="padding: 8px 8px 8px 0">
    <div class="d-flex">
      <a-button
        v-acl="'page_tpm_check_project_create'"
        type="primary"
        @click="openEditModal(false)"
        >{{ $t("page_tpm_check_project_create") || "新建点检" }}</a-button
      >
      <a-button
        v-acl="'page_tpm_check_project_edit'"
        class="ml-2"
        :disabled="!isUpdatable"
        @click="openEditModal(true)"
        >{{ $t("edit") || "编辑" }}</a-button
      >
      <a-button
        v-acl="'page_tpm_check_project_delete'"
        class="ml-2"
        type="danger"
        :disabled="!isDeletable"
        @click="remove"
        >{{ $t("delete") || "删除" }}</a-button
      >
      <import-button v-bind="importButtonAttrs"></import-button>
      <export-button v-bind="exportButtonAttrs"></export-button>
      <a-button
        class="ml-2"
        :disabled="!isPrint"
        @click="printing"
      >
       {{this.$t('page_print_code')}}
      </a-button>
      <a-input-search
        v-model="keyword"
        style="width: 240px; margin-left: auto"
        :placeholder="$t('common_please_input') + $t('keyword')"
        @search="onSearch"
        :enterButton="$t('search')"
      />
    </div>
    <ml-table v-bind="projectTableAttrs">
      <template #action="record">
        <a
          v-acl="'page_tpm_check_project_delete'"
          style="color: var(--color-red)"
          @click="remove([record.id])"
          >{{ $t("delete") || "删除" }}</a
        >
      </template>
    </ml-table>
    <ml-table v-bind="itemTableAttrs"></ml-table>
    <EditModal
      v-if="visible.editModal"
      :initialData="currentProject"
      :isUpdate="isUpdate"
      :checkList="checkList"
      @close="closeEditModal"
    />
    <CodeModel
     :visible="printVisible"
     @cancel="cancel"
     :dataList="dataList"
     @print="handlerPrint"
     >
     </CodeModel>
  </div>
</template>
